<template>
    <comHeader></comHeader>
          <!-- inner banner -->
    <div class="inner-banner">
        <section class="w3l-breadcrumb">
            <div class="container">
                <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">About Us</h4>
                <ul class="breadcrumbs-custom-path">
                    <li><a href="/">Home</a></li>
                    <li class="active"><span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>Privacy Policy</li>
                </ul>
            </div>
        </section>
    </div>
      <!-- //inner banner -->
    <section class="w3l-about-2 py-5">   
        <div class="container py-md-5 py-4">
            <div class="row align-items-center justify-content-between ">
            <!-- col-lg-6 about-2-secs-left pr-lg-5 -->
                <div style="width:100%;text-align: center;line-height: 100px">
                    <h1 class="title-style mb-sm-3 mb-2" >网站消费者业务隐私声明</h1>
                </div>
                <p>
                    网站及其全球附属公司（统称为“网站”、“我们”、“我们”或“我们的”）尊重您的隐私。我们特此制定本隐私声明（以下简称“本声明”），以帮助您了解我们如何收集、使用、披露、保护、储存和传输您的个人数据。请花点时间仔细阅读本声明，如有任何问题，请与我们联系。
 
                    本声明适用于显示或提及本声明的网站产品和服务，包括二维码、软件、工具包、网站和服务。
                </p>
                <div class="about-2-secs-left pr-lg-5">
                    <h3 style="text-align:center">网站如何收集和使用您的个人数据</h3>
                    <p>
                        个人信息是指以电子或其他方式记录的与已识别或可识别的自然人有关的任何类型的信息，不包括已匿名的信息。当您使用我们的产品或服务或与我们互动时，我们可能会收集您的个人数据。将收集不同类型的数据，具体取决于您使用的服务以及您与我们的互动。在某些情况下，您可以选择不提供此类数据，但这可能会阻止我们为您提供某些服务，或者可能意味着我们无法回应或解决您提出的任何问题。
                    </p>
                    <h3 style="text-align:center">网站如何保护您的个人数据</h3>
                    <p class="w3l-grids-block-5 font-stle">
                        您的个人数据的安全对我们很重要。我们采用了标准的行业惯例来保护您的个人数据免受未经授权的访问/披露/使用/修改、损坏或丢失。为此，我们采取以下措施:
 
                        1. 我们会采取一切合理和可行的措施，确保所收集的个人数据尽量少，并与处理这些数据的必要目的相关。
 
                        2. 我们使用加密技术来确保数据传输和存储的机密性，并实施可信的保护机制来保护数据和数据存储服务器免受攻击。
 
                        3. 我们部署了访问控制机制，仅允许授权访问您的个人数据。
 
                        4. 我们仔细挑选商业伙伴和服务提供商，并将个人数据保护要求纳入商业合同、审计和评估活动中。
 
                        5. 我们举办保安及私隐保护训练课程、测试及宣传活动，以提高雇员的个人数据保护意识。
 
                        我们完全致力于保护您的个人数据。然而，没有任何安全措施是完美的，没有任何产品、服务、网站、数据传输、计算机系统或网络连接是绝对安全的。
 
                        针对个人数据泄露、损坏、丢失等可能存在的风险，我们制定了若干机制和控制措施，明确了安全事件和漏洞的评级标准以及相应的处理程序。我们还成立了一个专门的安全应急响应小组，负责实施安全应急计划、减少损失、分析、定位和修复，并根据安全事件处理规定和要求与相关部门进行追踪/对抗操作。
                    </p>
                    <h3 style="text-align:center">本声明的更新</h3>
                    <p>
                        网站保留随时更新本声明的权利。本声明可能会不时更新。有关最新版本，请访问我们的官方网站。如果本声明发生重大变更，我们可能会通过不同的渠道通知您，例如在我们的网站上张贴通知或直接向您发送通知。
                    </p>
                    <h3 style="text-align:center">如何联系我们</h3>
                    <p>
                        我们有一个部门（或专家）致力于个人数据保护。如果您有任何问题、意见或建议，请通过客服联系我们。一般情况下，我们会在三个工作日内给予初步答复。                    
                    </p>
                </div>
            </div>
            <div>
                <p>
                    版权所有©网站保留所有权利。
                    更新时间:2025年07月08日
                </p>
            </div>
        </div>
    </section>
</template>

<script>
import comHeader from '../components/comHeader.vue';
export default{
    name: 'appPolicy',
    components:{
        comHeader
    }
}
</script>

<style>
</style>